/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 通过子市场获取推荐的代采组信息 的 **请求配置**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/SupplyDocumentDraft/getGroupMemberByMarket`
 */
const postGetGroupMemberByMarketRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyDocumentDraft/getGroupMemberByMarket",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetGroupMemberByMarket",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 通过子市场获取推荐的代采组信息 的 **请求函数**
 *
 * @分类 通用接口/公共模块
 * @请求头 `POST /erp/SupplyDocumentDraft/getGroupMemberByMarket`
 */
export const postGetGroupMemberByMarket = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetGroupMemberByMarketRequestConfig, requestData),
    ...args
  );
};
postGetGroupMemberByMarket.requestConfig =
  postGetGroupMemberByMarketRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 分页 的 **请求配置**
 *
 * @分类 新商家入驻/后台
 * @请求头 `POST /erp/SupplyDocumentDraft/page`
 */
const postPageRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/SupplyDocumentDraft/page",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postPage",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 分页 的 **请求函数**
 *
 * @分类 新商家入驻/后台
 * @请求头 `POST /erp/SupplyDocumentDraft/page`
 */
export const postPage = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postPageRequestConfig, requestData), ...args);
};
postPage.requestConfig = postPageRequestConfig;
/**
 * 接口 驳回 的 **请求配置**
 *
 * @分类 新商家入驻/后台
 * @请求头 `POST /erp/SupplyDocumentDraft/reject`
 */
const postRejectRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/SupplyDocumentDraft/reject",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postReject",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 驳回 的 **请求函数**
 *
 * @分类 新商家入驻/后台
 * @请求头 `POST /erp/SupplyDocumentDraft/reject`
 */
export const postReject = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postRejectRequestConfig, requestData), ...args);
};
postReject.requestConfig = postRejectRequestConfig;
/**
 * 接口 新商家建档详情 的 **请求配置**
 *
 * @分类 新商家入驻/后台
 * @请求头 `POST /erp/SupplyDocumentDraft/getFind`
 */
const postGetFindRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/SupplyDocumentDraft/getFind",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetFind",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 新商家建档详情 的 **请求函数**
 *
 * @分类 新商家入驻/后台
 * @请求头 `POST /erp/SupplyDocumentDraft/getFind`
 */
export const postGetFind = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetFindRequestConfig, requestData), ...args);
};
postGetFind.requestConfig = postGetFindRequestConfig;
/**
 * 接口 通过 的 **请求配置**
 *
 * @分类 新商家入驻/后台
 * @请求头 `POST /erp/SupplyDocumentDraft/pass`
 */
const postPassRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/SupplyDocumentDraft/pass",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postPass",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 通过 的 **请求函数**
 *
 * @分类 新商家入驻/后台
 * @请求头 `POST /erp/SupplyDocumentDraft/pass`
 */
export const postPass = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postPassRequestConfig, requestData), ...args);
};
postPass.requestConfig = postPassRequestConfig;
/**
 * 接口 操作日志列表 的 **请求配置**
 *
 * @分类 新商家入驻/后台
 * @请求头 `POST /erp/SupplyDocumentDraft/getFindLogs`
 */
const postGetFindLogsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/SupplyDocumentDraft/getFindLogs",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetFindLogs",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 操作日志列表 的 **请求函数**
 *
 * @分类 新商家入驻/后台
 * @请求头 `POST /erp/SupplyDocumentDraft/getFindLogs`
 */
export const postGetFindLogs = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetFindLogsRequestConfig, requestData), ...args);
};
postGetFindLogs.requestConfig = postGetFindLogsRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/supplyDocumentDraft.js